import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { loanSchema } from '../../helpers/validator';
import loanEligibilty from '../../api/loanEligibility';

export const loanSlice = createSlice({
  name: 'loan',
  initialState: {
    monoConnectKey: '',
    monoId: '',
    userName: 'Stranger',
    userData: {},
    statement: '',
    statementRecieved: false,
    exchangeTokenId: '',
    identity: {},
    monoAuthStatus: false,
    identityVerified: false,
    loanApproved: false,
    values: { amountToBorrow: '', yearsInmonths: '', interest: 8 },
  },
  reducers: {
    setValues: (state, action) => {
      state.values[action.payload.field] =
        action.payload.value.length > 0
          ? parseInt(action.payload.value, 10)
          : 0;
    },
    authAndGetLoan: (state, action) => {
      state.monoAuthStatus = true;
      state.identityVerified = true;
      state.userData = action.payload.info;
      state.statement = action.payload.payablePerMonth;
      state.loanApproved = action.payload.status === 'success' ? true : false;
    },
  },
});

export const { setValues, authAndGetLoan } = loanSlice.actions;

export const getExchangeToken = (
  monoId,
  setFirstBtnLoading,
  handlePrev
) => async (dispatch, getState) => {
  const values = getState().loan.values;
  const valid = await loanSchema.isValid(values);
  // console.log({ valid });
  const { amountToBorrow, yearsInmonths, interest } = values;
  try {
    setFirstBtnLoading(true);
    if (valid) {
      let result = await loanEligibilty.post('/authWithMono2', {
        monoId,
        amountToBorrow,
        yearsInmonths,
        interest,
      });
      // console.log({ result: result.data });
      toast.success('Authentication successful!');
      setFirstBtnLoading(false);
      dispatch(authAndGetLoan(result.data));
      handlePrev();
    } else {
      toast.error('Please fill form with non-zero, positive numbers');
      setFirstBtnLoading(false);
    }
  } catch (err) {
    // console.log({ err });
    toast.error('Oop, something went wrong!');
    setFirstBtnLoading(false);
  }
};

export const selectState = (state) => state.loan;
export const selectUserData = (state) => state.loan.userData;
export const selectMonoAuthStatus = (state) => state.loan.monoAuthStatus;
export const verifiedIdentity = (state) => state.loan.identityVerified;
export const username = (state) => state.loan.userName;
export const selectValues = (state) => state.loan.values;
export const selectLoanStatus = (state) => state.loan.loanApproved;
export default loanSlice.reducer;
